import {DropDownItem} from "../../../../../../modals/types/dropdown";
import {autoCompleteItem} from "../../../../../../modals/types/autocomplete";
import Dropdown from "../../../../../../ui/dropdown/dropdown";
import AutoComplete from "../../../../../../ui/autocomplete/autocomplete";
import {TabFormat} from "../../../../../../modals/types/tab";
import AdsTypeBox from "../../../../../../containers/adstypebox/adstypebox";
import FullAccordion from "../../../../../../ui/fullcoloraccordion/fullcoloraccordion";
import Pay from "../../../../../../modals/pay/pay";
import Tab0 from "../../../../../../components/campaigns/social-media-ads/instagram/view/post/adcard1/tab0/tab0";
import Tab1 from "../../../../../../components/campaigns/social-media-ads/instagram/view/post/adcard1/tab1/tab1";
import Tab3 from "../../../../../../components/campaigns/social-media-ads/instagram/view/post/adcard1/tab3/tab3";
import Stats from "../../../../../../ui/stats/stats";

const InstagramViewPost = (): JSX.Element[] => {
    const jobDropDownItems: DropDownItem[] = [
        {label: "صنعتی"}, {label: "مواد غذایی"}, {label: "مهندسی"}, {label: "صنایع"}
    ];
    const ageDropDownItems: DropDownItem[] = [
        {label: "از 0 تا 15 سال"}, {label: "از 15 سال تا 30 سال"}, {label: "از 30 سال تا 45 سال"}, {label: "صنایع"}
    ];
    const moneyDropDownItems: DropDownItem[] = [
        {label: "5 میلیون تومان"}, {label: "10 میلیون تومان"}, {label: "30 میلیون"}, {label: "50 میلیون"}
    ];
    const stateAutoCompleteItems: autoCompleteItem[] = [
        {title: "آذربایجان شرقی"}, {title: "تهران"}, {title: "مشهد"}, {title: "خوزستان"}
    ];
    const sellChannelAutoCompleteItems: autoCompleteItem[] = [
        {title: "وبسایت"}, {title: "اپلیکیشن"}, {title: "اینستاگرام"}, {title: "تلویزیون"}
    ];

    const renderAutoComplete = (): JSX.Element => {
        return (
            <div className="container" style={{marginBottom: '200px'}}>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">محصول/محصولات و یا خدمات شما</h6>
                        <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال:عسل"/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">حوزه کسب و کار</h6>
                        <Dropdown items={jobDropDownItems} placeHolder="مثال:مواد غذایی"/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">رده سنی مخاطبين و مشتریان شما</h6>
                        <Dropdown items={ageDropDownItems} placeHolder={"مثال:از ۱۶ تا ۳۰ سال"}/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">بودجه کلی کمپین تبلیغاتی شما</h6>
                        <Dropdown items={moneyDropDownItems} placeHolder={"مثال:۵۰ میلیون تومان"}/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">استان محل کسب و کار شما</h6>
                        <AutoComplete items={stateAutoCompleteItems} title={"مثال:همه ایران"}/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                        <h6 className="pt-4 pb-1">کانال های فروش شما</h6>
                        <AutoComplete items={sellChannelAutoCompleteItems} title={"مثال:وبسایت"}/>
                    </div>
                </div>
            </div>
        );
    }

    const scrollTabItems: TabFormat[] = [
        {
            tabs: ["محتوا", "انتخاب پیج / اینفلوینسر", "تنظیمات رسانه ها", "مشخصات کمپین"],
            tabPanel: [
                <Tab3/>,
                <div></div>,
                <Tab1/>,
                <Tab0/>,
            ]
        },
        {
            tabs: [""],
            tabPanel: [<div></div>]
        },
        {
            tabs: [""],
            tabPanel: [<div></div>]
        }
    ]

    const adsTypeCardNames = [
        "رسانه های اجتماعی", "تبلیغات در گوگل", "تبلیغات همسان"
    ]

    return [
        <FullAccordion/>,
        renderAutoComplete(),
        <Stats/>,
        <AdsTypeBox adsTypeCardNames={adsTypeCardNames} scrollTabItems={scrollTabItems}/>,
        <Pay/>,
    ];
}

export default InstagramViewPost;